import { Box } from '@mui/material';
import { ReactComponent as KioskClockIcon } from '../../../assets/icons/KioskClockIcon.svg';
import { ReactComponent as KioskDocumentIcon } from '../../../assets/icons/KioskDocumentIcon.svg';
import { KioskSection } from '../kiosk-selection-helpers';
import { KioskCard, KioskCardMeta, KioskCardMetaTime, KioskCardName } from '../styles';
import ElapsedCounter from './ElapsedCounter';

export interface KioskEmployeeCardProps {
  variant: KioskSection;
  fullName: string;
  /** Active only — drives the live elapsed counter. */
  startTimeUtc?: string;
  /** Right-side `HH:mm`: active = start time, planned = planned start; omitted for 'other'. */
  timeLabel?: string;
  /** Display-only for US 7346: wired but a no-op. */
  onSelect?: () => void;
}

/** One employee row. `active` shows a live counter + clock/start time; `planned` shows a doc icon + start; `other` is name-only. */
const KioskEmployeeCard = ({ variant, fullName, startTimeUtc, timeLabel, onSelect }: KioskEmployeeCardProps) => (
  <KioskCard clickable={Boolean(onSelect)} onClick={onSelect}>
    <Box sx={{ minWidth: 0 }}>
      <KioskCardName>{fullName}</KioskCardName>
      {variant === 'active' && startTimeUtc ? <ElapsedCounter startTimeUtc={startTimeUtc} /> : null}
    </Box>
    {variant !== 'other' && timeLabel ? (
      <KioskCardMeta>
        {variant === 'active' ? <KioskClockIcon /> : <KioskDocumentIcon />}
        <KioskCardMetaTime>{timeLabel}</KioskCardMetaTime>
      </KioskCardMeta>
    ) : null}
  </KioskCard>
);

export default KioskEmployeeCard;
